import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { Auth } from '@core/services';

export const publicGuard: CanActivateFn = () => {
  const authService = inject(Auth);
  const router = inject(Router);

  const token = authService.token;
  const user = authService.user;

  if (token && user) {
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
